module.exports = __webpack_public_path__ + "static/media/orginfo-bg.5a1e389d.jpg";